import { CardTabs } from 'vopay';

import React, { FunctionComponent, useState } from 'react';

import BillingSettingsList from './BillingSettingsList';
import PlanSettingsList from './PlanSettingsList';
import { useTranslation } from 'react-i18next';

type TabContents = {
  billingSettings: React.JSX.Element;
  planSettings: React.JSX.Element;
};

type FC = FunctionComponent<Record<never, never>>;

const BillingPackageTabs: FC = () => {
  const [activeTab, setActiveTab] = useState<keyof TabContents>('billingSettings');
  const { t } = useTranslation('translations', { keyPrefix: 'BillingPackage.Details' });
  const handleTabChange = (value: string) => {
    if (value === 'billingSettings' || value === 'planSettings') {
      setActiveTab(value);
    }
  };

  return (
    <CardTabs.Root value={activeTab} onValueChange={handleTabChange}>
      <CardTabs.List aria-label={t('tabsAriaLabel', { defaultValue: 'Billing Package Details' })}>
        <CardTabs.Trigger value="billingSettings">{t('billingSettingsTab')}</CardTabs.Trigger>
        <CardTabs.Trigger value="planSettings">{t('planSettingsTab')}</CardTabs.Trigger>
      </CardTabs.List>
      <CardTabs.Content key="billingSettings" value="billingSettings">
        <BillingSettingsList />
      </CardTabs.Content>
      <CardTabs.Content key="planSettings" value="planSettings">
        <PlanSettingsList />
      </CardTabs.Content>
    </CardTabs.Root>
  );
};

export default BillingPackageTabs;
